module.exports = __webpack_public_path__ + "static/2-a765e45b06eecfc730fc2215da805c32.jpg";